import React from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from '../components/layout';
import { TabNavigation } from '../components/navigation';
import QueryParamsDebug from '../components/debug/QueryParamsDebug';

export const MainLayout: React.FC = () => {

  return (
    <div className="flex flex-col min-h-screen pt-16">
      {/* Tab Navigation (en haut de la page) */}
      <TabNavigation />
      
      {/* Main Content */}
      <main className="flex-grow container mx-auto px-4 py-4 md:py-8">
        <Outlet />
      </main>

      {/* Footer */}
      {/* <Footer /> */}
      
      {/* Debug component to show URL parameters */}
      {/* <QueryParamsDebug /> */}
    </div>
  );
};
